<template>
    <div>
        <div class="cs-nav">
            <ul data-switchmenu data-isonlyoneopen="false" class="nav-scroll mySideBarTop">
                <li class="nav-border">
                    <div class="nav-pro">
                        <div class="pro-img" v-if="project.imagePath != null && project.imagePath.length > 0" :style = "{background:'url('+project.imagePath+') no-repeat center / cover'}"></div>
                        <img v-else src=".././assets/images/silder_project_ico.png" width="50"/>
                        <div class="text">{{projectName}}</div>
                        <div v-if="project.state == 0" class="cs-btn btn-warning">{{$store.state.i18n.ongoing[$store.state.CN_EN]}}</div>
                        <div v-else-if="project.state == 2" class="cs-btn btn-success">{{$store.state.i18n.notNotice[$store.state.CN_EN]}}</div>
                    </div>
                </li>
                <!--<li class="nav-border">
                    <div class="parent-wrap">
                        <a href="" class="nav-parent">
                            <img src=".././assets/images/silder_project_data.png" class="nav-img">
                            <img src=".././assets/images/silder_project_data_selected.png" class="nav-imgSel">
                            <span>统计</span>
                        </a>
                    </div>
                </li>-->
                <li class="nav-border">
                    <div class="parent-wrap">
                        <a :href="encodeURI('bugList.html?'+projectId+'&'+projectName)" class="nav-parent"><!--active-->
                            <img src=".././assets/images/silder_project_bug.png" class="nav-img">
                            <img src=".././assets/images/silder_project_bug_selected.png" class="nav-imgSel">
                            <span>Bug</span>
                        </a>
                    </div>
                </li>
                <li class="nav-border">
                    <div class="parent-wrap">
                        <a :href="encodeURI('missionList.html?'+projectId+'&'+projectName)" class="nav-parent">
                            <img src=".././assets/images/silder_project_task.png" class="nav-img">
                            <img src=".././assets/images/silder_project_task_selected.png" class="nav-imgSel">
                            <span>{{$store.state.i18n.task[$store.state.CN_EN]}}</span>
                        </a>
                    </div>
                </li>
                <li class="nav-border">
                    <div class="parent-wrap">
                        <a :href="encodeURI('testCaseList.html?'+projectId+'&'+projectName)" class="nav-parent">
                            <img src=".././assets/images/silder_project_case.png" class="nav-img">
                            <img src=".././assets/images/silder_project_case_selected.png" class="nav-imgSel">
                            <span>{{$store.state.i18n.testCase[$store.state.CN_EN]}}</span>
                        </a>
                    </div>
                </li>
                <li class="nav-border"v-if="role !== 'RoleCustomer'">
                    <div class="parent-wrap">
                        <a :href="encodeURI('memberList.html?'+projectId+'&'+projectName)" class="nav-parent">
                            <img src=".././assets/images/silder_project_member.png" class="nav-img">
                            <img src=".././assets/images/silder_project_member_selected.png" class="nav-imgSel">
                            <span>{{$store.state.i18n.member[$store.state.CN_EN]}}</span>
                        </a>
                    </div>
                </li>
                <li class="nav-border" v-if="role !== 'RoleCustomer'">
                    <div class="parent-wrap">
                        <a :href="encodeURI('moduleLevelOne.html?'+projectId+'&'+projectName)" class="nav-parent">
                            <img src=".././assets/images/silder_project_module.png" class="nav-img">
                            <img src=".././assets/images/silder_project_module_selected.png" class="nav-imgSel">
                            <span>{{$store.state.i18n.module[$store.state.CN_EN]}}</span>
                        </a>
                    </div>
                </li>
                <li class="nav-border" v-show="isShow != null && isShow">
                    <div class="parent-wrap">
                        <a :href="encodeURI('setting.html?'+projectId+'&'+projectName)" class="nav-parent">
                            <img src=".././assets/images/silder_project_setting.png" class="nav-img">
                            <img src=".././assets/images/silder_project_setting_selected.png" class="nav-imgSel">
                            <span>{{$store.state.i18n.set[$store.state.CN_EN]}}</span>
                        </a>
                    </div>
                </li>
            </ul>
            <div class="contact">
                <div>{{$store.state.i18n.contactUs[$store.state.CN_EN]}}</div>
                <a class="email" href="mailto:ahsun.Chen@chisalsoft.com?subject=Bugx咨询">ahsun.chen@chisalsoft.com</a>
                <div class="btn-phone">
                    <img src=".././assets/images/silder_ico_call.png" width="16">
                    <span class="text-phone">181 3608 1199</span>
                </div>
                <img src=".././assets/images/silder_ico_line.png" width="163" class="btn-line">
                <div class="btn-phone hover" @click="showAdviceAlert">
                    <img src=".././assets/images/silder_ico_problem.png" width="16">
                    <span class="text-phone">{{$store.state.i18n.feedbackBtnInfo[$store.state.CN_EN]}}</span>
                </div>
            </div>
        </div>
        <el-dialog :title="$store.state.i18n.feedbackBtnInfo[$store.state.CN_EN]" :visible.sync="advise" :show-close=false width="660px" :close-on-click-modal="false">
            <div class="cs-mb-15">
                <span class="advise-text">{{$store.state.i18n.feedbackType[$store.state.CN_EN]}}：</span>
                <div class="user-input">
                    <div class="btn-type" @click="theType = 0" :class="{'active': theType== 0}">{{$store.state.i18n.feedbackAdvice[$store.state.CN_EN]}}</div>
                    <div class="btn-type" @click="theType = 1" :class="{'active': theType== 1}">{{$store.state.i18n.feedbackProblem[$store.state.CN_EN]}}</div>
                </div>
            </div>
            <div class="cs-mb-15">
                <span class="advise-text vertical-t">{{$store.state.i18n.feedbackContent[$store.state.CN_EN]}}：</span>
                <div class="user-input">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 5}"
                            :placeholder="$store.state.i18n.feedBackInputRemindOne[$store.state.CN_EN]"
                            v-model="content">
                    </el-input>
                </div>
            </div>
            <div class="cs-mb-15">
                <span class="advise-text">{{$store.state.i18n.contactWay[$store.state.CN_EN]}}：</span>
                <div class="user-input">
                    <el-input
                            type="text"
                            :placeholder="$store.state.i18n.feedBackInputRemindTwo[$store.state.CN_EN]"
                            v-model="contact">
                    </el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="cs-btn btn-cancel" @click="cancel">{{$store.state.i18n.cancel[$store.state.CN_EN]}}</div>
                <div class="cs-btn btn-sure" @click="startAddAdviceRequest">{{$store.state.i18n.ok[$store.state.CN_EN]}}</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import $ from 'jquery';
    import Vue from 'vue'
    import {Dialog,Input} from 'element-ui';
    Vue.use(Dialog)
    Vue.use(Input)

    export default {
        name:"side",
        data() {
            return {
                projectId:null,
                projectName:null,
                project:{},
                role:null,
                isShow:false,
                advise:false,
                theType:0,
                content:'',
                contact:'',

                // phoneNumber: null,
            }
        },
        computed: {
            addAdviceRequestForm() {
                return {
					interfaceVersion		:	19000101,
					adviceType				:	this.theType,
					content					: 	this.content,
					contactWay 				: 	this.contact
                }
            }
        },
        mounted(){
            //根据Url中的参数，初始化数据
            this.$byUrlInitValue("&", this, ["projectId", "projectName"]);
            // console.info(this.projectId)

            this.contact = localStorage.getItem("phoneNumber")

            //设置页面，每个登录用户都能看到
            this.getProjectSimpleInfo()
        },
        methods : {
            // initData:initData,
            enterNewPage:enterNewPage,
            getProjectSimpleInfo:getProjectSimpleInfo,


			startAddAdviceRequest () {
				this.$api.post('/smAdviceAdd.smhtml', this.addAdviceRequestForm, jsonObj => {


					this.$message.success(this.$store.state.i18n.feedBackSuccessInfo[this.$store.state.CN_EN])
                    this.advise = false
                    this.theType = 0
                    this.content = ''
                    this.contact = localStorage.getItem("phoneNumber")

				},jsonObj => {
					this.$message.error(jsonObj.info)
				})
            },
            showAdviceAlert() {
                this.advise = true
            },
            cancel () {
                this.advise = false
                this.theType = 0
                this.content = ''
                this.contact = localStorage.getItem("phoneNumber")
            }
        },
        watch : {
            '$store.state.enterPageUrl': function(){
                this.enterNewPage(this.$store.state.enterPageUrl);
            }
        }
    }

    // function initData() {
    //     this.projectId  = this.$cookie.get('projectId')
    //     this.projectName  = this.$cookie.get('projectName')
    // }

    function getProjectSimpleInfo() {
        let this_ = this
        let model = {
            interfaceVersion:19000101,
            projectId:this.projectId,
        }
        // console.log(model);
        this.$api.post('/smProjectSimpleInfoDetail.smhtml', model, jsonObj => {
            // console.log(jsonObj);
            this.project = jsonObj.project;
            this.role = jsonObj.role;
            /**
             * 从2020-03-21起，登录后的用户都能够设置是否接收邮件，动态控制，只有项目经理可以看到设置
             */
            // Vue.nextTick(function () {
            //     if(jsonObj.role == 'RoleProjectManager') this_.isShow = true
            // })
            // that.$message.success(jsonObj.info);
        },jsonObj => {
            // console.log(jsonObj);
            this.$message.error(jsonObj.info);
        })

        /**
         * 从2020-03-21起，登录后的用户都能够设置是否接收邮件，默认显示
         */
        this.isShow = true
    }

    /**
     * 作者：Joy.Jiang,Ben.Gu,Percy.Hu
     * 时间：2019-06-05
     * 描述：动态选中，用户当前打开的菜单
     */
    function enterNewPage(pageUrl)
    {
        if(pageUrl == null) return;
        // console.info(pageUrl)

        $('ul[data-switchmenu] a').each(function(){
            let hrefUrl = $(this).attr("href");
            if(hrefUrl != null && hrefUrl.indexOf('?') > -1)
            {
                hrefUrl = hrefUrl.split('?')[0];
            }

            if(pageUrl == hrefUrl)
            {
                let current = $(this);//a标签

                /**
                 * 规范：
                 *      class 中含有 nav-parent 就是 a 标签
                 *      class 中含有 nav-child 就是 ul 标签
                 * 其中
                 *      是a标签，就加样式“active”-->表示“选中”
                 *      是ul标签，就加样式“open” -->表示“展开”
                 */
                while(current != null && !current.hasClass("mySideBarTop"))
                {
                    if(current.hasClass("nav-parent"))
                    {
                        current.addClass("active");
                    }

                    current = current.parent();

                    //判断是否是Ul
                    if(current != null && current.hasClass("nav-child"))
                    {
                        current.addClass("open");
                        current.prev().addClass("active");
                        current.show();
                    }
                }
            }
        });
        $(".nav-parent.active").parent().css('background-color', '#d5e7e4');
        $(".nav-user .nav-parent.active").parent().css('background-color', 'transparent');
    }
</script>

<style scoped>
    .pro-img{
        width: 135px;
        height: 70px;
        background-size: cover;
        border-radius: 4px;
        margin: 0 auto;
    }
    .cs-nav{
        background-color: #fff;
        width: 200px;
        height: 100%;
        display: inline-block;
        box-sizing: border-box;
        position: fixed;
        left: 0;
        top: 73px;
        vertical-align: top;
        overflow-x: hidden;
        z-index: 12;
        transition: all 0.3s;
    }
    .cs-close .cs-nav{
        width:0;
    }
    .cs-close .cs-top,.cs-close .cs-content{
        padding-left: 20px;
    }
    .nav-scroll{
        height: calc(100% - 262px);
        overflow-y: auto;
        overflow-x: hidden;
        width: 217px;
        box-sizing: border-box;
    }
    .nav-parent{
        width: 200px;
        font-size: 15px;
        display: block;
        text-decoration: none;
        color: #193653;
        padding: 15px 0;
        cursor: pointer;
        border-left:3px solid transparent;
        box-sizing: border-box;
    }
    .nav-parent img{
        width: 20px;
        margin: 0 25px;
    }
    .nav-parent span{
        vertical-align: middle;
    }
    .nav-parent.active{
        border-left:3px solid #1ab3a6;
        background-color: #f3fbfa;
    }
    .nav-parent .nav-imgSel{
        display: none;
    }
    .nav-parent.active .nav-img{
        display: none;
    }
    .nav-parent.active .nav-imgSel{
        display: inline-block;
        opacity: 1;
    }
    .nav-child{
        margin: 0;
        padding: 0;
    }
    .nav-child .nav-parent{
        padding: 6px 0 6px 78px;
        line-height: 19px;
    }
    .nav-child .nav-parent+.nav-child .nav-parent{
        padding-left: 95px;
    }
    .nav-child .nav-parent.active{
        background: #252c35;
    }
    .nav-child .nav-parent span{
        display: block;
        width: 155px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .parent-wrap{
        position: relative;
        cursor: pointer;
    }
    .nav-child .nav-border {
        border-bottom: none;
    }
    .child-icon{
        position: absolute;
        left: 200px;
        top: 16px;
        line-height: 21px;
    }
    .nav-child .child-icon{
        top: 5px;
    }
    .child-icon img{
        width: 12px;
    }
    .child-icon .icon-up{
        display: none;
    }
    .nav-child.open+.child-icon .icon-up{
        display: inline-block;
    }
    .nav-child.open+.child-icon .icon-down{
        display: none;
    }
    .cs-btn{
        display: inline-block;
        color: #fff;
        border-radius: 4px;
        font-size: 12px;
        padding: 1px 3px;
    }
    .btn-warning{
        background: #ffb42d;
    }
    .nav-pro{
        width: 200px;
        text-align: center;
        padding: 20px 0 15px 0;
    }
    .nav-pro .text{
        color: #333333;
        font-weight: bold;
        padding: 13px 10px;
    }
    .contact{
        position: absolute;
        bottom: 85px;
        width: 100%;
        color: #0e3458;
        font-size: 13px;
        text-align: center;
    }
    .btn-phone{
        width: 172px;
        font-size: 15px;
        border: 1px solid #dcdcdc;
        border-radius:4px;
        color: #3376f1;
        display: inline-block;
        padding: 10px 0px;
    }
    .text-phone{
        color: #0e3458;
        margin-left: 5px;
        vertical-align: middle;
        display: inline-block;
    }
    .btn-line{
        margin: 15px auto;
    }
    .email{
        color: #136ee3;
        margin: 10px 0 15px 0;
        display: block;
    }
    /*弹窗*/
    .btn-cancel, .btn-sure {
        font-size: 14px;
        min-width: 80px;
        padding: 7px 25px;
        box-sizing: border-box;
        border: 1px solid #29b6b0;
        cursor: pointer;
    }
    .btn-cancel {
        color: #29b6b0;
    }
    .user-input {
        display: inline-block;
        width: 530px;
        position: relative;
    }
    .advise-text {
        display: inline-block;
        width: 80px;
    }
    .vertical-t{
        vertical-align: top;
    }
    .btn-type{
        border: 1px solid #d2d2d2;
        color: #333333;
        border-radius: 4px;
        display: inline-block;
        padding: 10px 30px;
        margin-right: 10px;
        cursor: pointer;
    }
    .btn-type.active{
        color: #29b6b0;
        border: 1px solid #29b6b0;
    }
</style>
